import { NavLink } from 'react-router-dom';
import classnames from 'classnames';

const SidebarItems = (props) => {
  const RenderNavItems = props.items.map((item, index) => (
    <li
      className={classnames({
        'nav-item': !item.children,
        disabled: item.disabled
        //active: item.navLink === activeItem,
      })}
    >
      <NavLink
        className={classnames('d-flex align-items-center', {
          //active: item.navLink === activeItem,
        })}
        to={item.navLink || '/'}
        onClick={(e) => {
          if (item.navLink.length === 0 || item.navLink === '#' || item.disabled === true) {
            e.preventDefault();
          }
        }}
      >
        {item.icon}
        <span className="menu-item text-truncate">{item.title}</span>
      </NavLink>
    </li>
  ));

  return RenderNavItems;
};

export default SidebarItems;
